import React from 'react';

const BlankLoader = () => (
    <div className="text-center loding-product-count" style={{ marginTop: '60px' }}>
        <img alt="loader" src="//static2.lenskart.com/skin/frontend/base/default/images/ajaxscroll/loader.gif" />
    </div>
);

export default BlankLoader;
